import carrierImg100 from '../images/carrierIcons/100.png';
import carrierImg101 from '../images/carrierIcons/101.png';
import carrierImg1011 from '../images/carrierIcons/1011.png';
import carrierImg103 from '../images/carrierIcons/103.png';
import carrierImg104 from '../images/carrierIcons/104.png';
import carrierImg105 from '../images/carrierIcons/105.png';
import carrierImg108 from '../images/carrierIcons/108.png';
import carrierImg109 from '../images/carrierIcons/109.png';
import carrierImg110 from '../images/carrierIcons/110.png';
import carrierImg111 from '../images/carrierIcons/111.png';
import carrierImg117 from '../images/carrierIcons/117.png';
import carrierImg118 from '../images/carrierIcons/118.png';
import carrierImg119 from '../images/carrierIcons/119.png';
import carrierImg120 from '../images/carrierIcons/120.png';
import carrierImg121 from '../images/carrierIcons/121.png';
import carrierImg126 from '../images/carrierIcons/126.png';
import carrierImg131 from '../images/carrierIcons/131.png';
import carrierImg132 from '../images/carrierIcons/132.png';
import carrierImg133 from '../images/carrierIcons/133.png';
import carrierImg134 from '../images/carrierIcons/134.png';
import carrierImg135 from '../images/carrierIcons/135.png';
import carrierImg137 from '../images/carrierIcons/137.png';
import carrierImg138 from '../images/carrierIcons/138.png';
import carrierImg139 from '../images/carrierIcons/139.png';
import carrierImg140 from '../images/carrierIcons/140.png';
import carrierImg141 from '../images/carrierIcons/141.png';
import carrierImg143 from '../images/carrierIcons/143.png';
import carrierImg144 from '../images/carrierIcons/144.png';
import carrierImg145 from '../images/carrierIcons/145.png';
import carrierImg146 from '../images/carrierIcons/146.png';
import carrierImg147 from '../images/carrierIcons/147.png';
import carrierImg163 from '../images/carrierIcons/163.png';
import carrierImg164 from '../images/carrierIcons/164.png';
import carrierImg165 from '../images/carrierIcons/165.png';
import carrierImg166 from '../images/carrierIcons/166.png';
import carrierImg168 from '../images/carrierIcons/168.png';
import carrierImg169 from '../images/carrierIcons/169.png';
import carrierImg170 from '../images/carrierIcons/170.png';
import carrierImg171 from '../images/carrierIcons/171.png';
import carrierImg172 from '../images/carrierIcons/172.png';
import carrierImg173 from '../images/carrierIcons/173.png';
import carrierImg174 from '../images/carrierIcons/174.png';
import carrierImg175 from '../images/carrierIcons/175.png';
import carrierImg176 from '../images/carrierIcons/176.png';
import carrierImg1779 from '../images/carrierIcons/1779.png';
import carrierImg178 from '../images/carrierIcons/178.png';
import carrierImg179 from '../images/carrierIcons/179.png';
import carrierImg180 from '../images/carrierIcons/180.png';
import carrierImg182 from '../images/carrierIcons/182.png';
import carrierImg1840 from '../images/carrierIcons/1840.png';
import carrierImg185 from '../images/carrierIcons/185.png';
import carrierImg186 from '../images/carrierIcons/186.png';
import carrierImg1863 from '../images/carrierIcons/1863.png';
import carrierImg187 from '../images/carrierIcons/187.png';
import carrierImg1870 from '../images/carrierIcons/1870.png';
import carrierImg1871 from '../images/carrierIcons/1871.png';
import carrierImg1874 from '../images/carrierIcons/1874.png';
import carrierImg1875 from '../images/carrierIcons/1875.png';
import carrierImg1877 from '../images/carrierIcons/1877.png';
import carrierImg188 from '../images/carrierIcons/188.png';
import carrierImg189 from '../images/carrierIcons/189.png';
import carrierImg1896 from '../images/carrierIcons/1896.png';
import carrierImg190 from '../images/carrierIcons/190.png';
import carrierImg1901 from '../images/carrierIcons/1901.png';
import carrierImg1905 from '../images/carrierIcons/1905.png';
import carrierImg191 from '../images/carrierIcons/191.png';
import carrierImg1914 from '../images/carrierIcons/1914.png';
import carrierImg1915 from '../images/carrierIcons/1915.png';
import carrierImg1916 from '../images/carrierIcons/1916.png';
import carrierImg1917 from '../images/carrierIcons/1917.png';
import carrierImg192 from '../images/carrierIcons/192.png';
import carrierImg1924 from '../images/carrierIcons/1924.png';
import carrierImg1927 from '../images/carrierIcons/1927.png';
import carrierImg1928 from '../images/carrierIcons/1928.png';
import carrierImg193 from '../images/carrierIcons/193.png';
import carrierImg1938 from '../images/carrierIcons/1938.png';
import carrierImg1939 from '../images/carrierIcons/1939.png';
import carrierImg194 from '../images/carrierIcons/194.png';
import carrierImg195 from '../images/carrierIcons/195.png';
import carrierImg1950 from '../images/carrierIcons/1950.png';
import carrierImg1957 from '../images/carrierIcons/1957.png';
import carrierImg1958 from '../images/carrierIcons/1958.png';
import carrierImg1960 from '../images/carrierIcons/1960.png';
import carrierImg1961 from '../images/carrierIcons/1961.png';
import carrierImg197 from '../images/carrierIcons/197.png';
import carrierImg1996 from '../images/carrierIcons/1996.png';
import carrierImg202 from '../images/carrierIcons/202.png';
import carrierImg2020 from '../images/carrierIcons/2020.png';
import carrierImg2028 from '../images/carrierIcons/2028.png';
import carrierImg2029 from '../images/carrierIcons/2029.png';
import carrierImg2030 from '../images/carrierIcons/2030.png';
import carrierImg2031 from '../images/carrierIcons/2031.png';
import carrierImg2032 from '../images/carrierIcons/2032.png';
import carrierImg2036 from '../images/carrierIcons/2036.png';
import carrierImg2037 from '../images/carrierIcons/2037.png';
import carrierImg2494 from '../images/carrierIcons/2494.png';
import carrierImg204 from '../images/carrierIcons/204.png';
import carrierImg205 from '../images/carrierIcons/205.png';
import carrierImg206 from '../images/carrierIcons/206.png';
import carrierImg207 from '../images/carrierIcons/207.png';
import carrierImg208 from '../images/carrierIcons/208.png';
import carrierImg209 from '../images/carrierIcons/209.png';
import carrierImg210 from '../images/carrierIcons/210.png';
import carrierImg217 from '../images/carrierIcons/217.png';
import carrierImg218 from '../images/carrierIcons/218.png';
import carrierImg219 from '../images/carrierIcons/219.png';
import carrierImg220 from '../images/carrierIcons/220.png';
import carrierImg264 from '../images/carrierIcons/264.png';
import carrierImg291 from '../images/carrierIcons/291.png';
import carrierImg3163 from '../images/carrierIcons/3163.png';
import carrierImg3165 from '../images/carrierIcons/3165.png';
import carrierImg317 from '../images/carrierIcons/317.png';
import carrierImg324 from '../images/carrierIcons/324.png';
import carrierImg340 from '../images/carrierIcons/340.png';
import carrierImg346 from '../images/carrierIcons/346.png';
import carrierImg3628 from '../images/carrierIcons/3628.png';
import carrierImg3944 from '../images/carrierIcons/3944.png';
import carrierImg3952 from '../images/carrierIcons/3952.png';
import carrierImg3955 from '../images/carrierIcons/3955.png';
import carrierImg832 from '../images/carrierIcons/832.png';
import carrierImg1937 from '../images/carrierIcons/1937.png';
import carrierImg3212 from '../images/carrierIcons/3212.jpg';
import carrierImg1897 from '../images/carrierIcons/1897.png';

const getCarrierIcon = carrierId => {
  switch (carrierId) {
    case 100:
      return carrierImg100;
    case 101:
      return carrierImg101;
    case 1011:
      return carrierImg1011;
    case 103:
      return carrierImg103;
    case 104:
      return carrierImg104;
    case 105:
      return carrierImg105;
    case 108:
      return carrierImg108;
    case 109:
      return carrierImg109;
    case 110:
      return carrierImg110;
    case 111:
      return carrierImg111;
    case 117:
      return carrierImg117;
    case 118:
      return carrierImg118;
    case 119:
      return carrierImg119;
    case 120:
      return carrierImg120;
    case 121:
      return carrierImg121;
    case 126:
      return carrierImg126;
    case 131:
      return carrierImg131;
    case 132:
      return carrierImg132;
    case 133:
      return carrierImg133;
    case 134:
      return carrierImg134;
    case 135:
      return carrierImg135;
    case 137:
      return carrierImg137;
    case 138:
      return carrierImg138;
    case 139:
      return carrierImg139;
    case 140:
      return carrierImg140;
    case 141:
      return carrierImg141;
    case 143:
      return carrierImg143;
    case 144:
      return carrierImg144;
    case 145:
      return carrierImg145;
    case 146:
      return carrierImg146;
    case 147:
      return carrierImg147;
    case 163:
      return carrierImg163;
    case 164:
      return carrierImg164;
    case 165:
      return carrierImg165;
    case 166:
      return carrierImg166;
    case 168:
      return carrierImg168;
    case 169:
      return carrierImg169;
    case 170:
      return carrierImg170;
    case 171:
      return carrierImg171;
    case 172:
      return carrierImg172;
    case 173:
      return carrierImg173;
    case 174:
      return carrierImg174;
    case 175:
      return carrierImg175;
    case 176:
      return carrierImg176;
    case 1779:
      return carrierImg1779;
    case 178:
      return carrierImg178;
    case 179:
      return carrierImg179;
    case 180:
      return carrierImg180;
    case 182:
      return carrierImg182;
    case 1840:
      return carrierImg1840;
    case 185:
      return carrierImg185;
    case 186:
      return carrierImg186;
    case 1863:
      return carrierImg1863;
    case 187:
      return carrierImg187;
    case 1870:
      return carrierImg1870;
    case 1871:
      return carrierImg1871;
    case 1874:
      return carrierImg1874;
    case 1875:
      return carrierImg1875;
    case 1877:
      return carrierImg1877;
    case 188:
      return carrierImg188;
    case 189:
      return carrierImg189;
    case 1896:
      return carrierImg1896;
    case 190:
      return carrierImg190;
    case 1901:
      return carrierImg1901;
    case 1905:
      return carrierImg1905;
    case 191:
      return carrierImg191;
    case 1914:
      return carrierImg1914;
    case 1915:
      return carrierImg1915;
    case 1916:
      return carrierImg1916;
    case 1917:
      return carrierImg1917;
    case 192:
      return carrierImg192;
    case 1924:
      return carrierImg1924;
    case 1927:
      return carrierImg1927;
    case 1928:
      return carrierImg1928;
    case 193:
      return carrierImg193;
    case 1938:
      return carrierImg1938;
    case 1939:
      return carrierImg1939;
    case 194:
      return carrierImg194;
    case 195:
      return carrierImg195;
    case 1950:
      return carrierImg1950;
    case 1957:
      return carrierImg1957;
    case 1958:
      return carrierImg1958;
    case 1960:
      return carrierImg1960;
    case 1961:
      return carrierImg1961;
    case 197:
      return carrierImg197;
    case 1996:
      return carrierImg1996;
    case 202:
      return carrierImg202;
    case 2020:
      return carrierImg2020;
    case 2028:
      return carrierImg2028;
    case 2029:
      return carrierImg2029;
    case 2030:
      return carrierImg2030;
    case 2031:
      return carrierImg2031;
    case 2032:
      return carrierImg2032;
    case 2036:
      return carrierImg2036;
    case 2037:
      return carrierImg2037;
    case 2494:
      return carrierImg2494;
    case 204:
      return carrierImg204;
    case 205:
      return carrierImg205;
    case 206:
      return carrierImg206;
    case 207:
      return carrierImg207;
    case 208:
      return carrierImg208;
    case 209:
      return carrierImg209;
    case 210:
      return carrierImg210;
    case 217:
      return carrierImg217;
    case 218:
      return carrierImg218;
    case 219:
      return carrierImg219;
    case 220:
      return carrierImg220;
    case 264:
      return carrierImg264;
    case 291:
      return carrierImg291;
    case 3163:
      return carrierImg3163;
    case 3165:
      return carrierImg3165;
    case 317:
      return carrierImg317;
    case 324:
      return carrierImg324;
    case 340:
      return carrierImg340;
    case 346:
      return carrierImg346;
    case 3628:
      return carrierImg3628;
    case 3944:
      return carrierImg3944;
    case 3952:
      return carrierImg3952;
    case 3955:
      return carrierImg3955;
    case 832:
      return carrierImg832;
    case 1937:
      return carrierImg1937;
    case 1897:
      return carrierImg1897;
    case 3212:
      return carrierImg3212;
    default:
      return '';
  }
};

export default getCarrierIcon;
